import { notificationClearImgBase64 } from './notification-clear-img';
/* eslint-disable no-unused-vars */
export const notificationQueue = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '.unified-notification-queue': {

    '& .notification-queue': {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: 460,
      border: 0,
      textAlign: 'left',
      cursor: 'auto',
      lineHeight: 'normal',

      '& .title': {
        fontWeight: 'bold',
        wordBreak: 'break-word',
      },

      '& .notification-queue-dismiss': {
        position: 'absolute',
        top: 20,
        right: 20,
        zIndex: 6001,
        minWidth: 12,
      },

      '& .notification-queue-header': {
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '27px',
        color: '#323130',

        '& .notification-queue-header-content-wrapper': {
          padding: 0,

          '& hr': {
            display: 'none',
          },
        },
      },

      '& .notification-queue-empty': {
        padding: '37px 26px 5px',
        backgroundColor: '#FAF9F8',

        '& .empty-content': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'auto',

          '& .glasses': {
            display: 'block',
            margin: '14px 0px 16px 0px',
            width: 239,
            height: '216px',
            backgroundImage: `url("data:image/svg+xml;base64, ${notificationClearImgBase64}")`,
            backgroundRepeat: 'no-repeat',
          },

          '& .empty-text': {
            fontSize: 14,
            color: '#605e5c',
            fontWeight: 600,
          },
        },
      },

      '& .notification-queue-display': {
        fontSize: 14,
        height: 'calc(100vh - 60px)',
        minHeight: '350px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',

        '& .notification-queue-header': {
          left: 0,
          right: 0,
          padding: '37px 15px 21px',
          zIndex: 6000,
          backgroundColor: '#FAF9F8',

          '& .notification-queue-header-content-wrapper': {
            backgroundColor: '#FAF9F8',

            '& .action-link': {
              fontSize: 14,
              color: '#005A9E',
              position: 'absolute',
              right: 15,
              top: 40,
              height: 22,
              fontWeight: 'normal',
              lineHeight: '22px',
              zIndex: 6001,

              '& .btn-link': {
                color: '#0078D4',
                height: 22,
                padding: '0 4px',
              },
            },
          },
        },

        '& .notification-queue-footer': {
          fontSize: 14,
          width: 460,
          backgroundColor: '#FAF9F8',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',

          '& .action-link': {
            padding: '4px 15px',
            color: '#005A9E',
            alignSelf: 'flex-end',
          },

          '& .hint-message': {
            color: '#323130',
            backgroundColor: '#eff6fc',
            border: 'none',
            boxShadow: 'none',
            display: 'flex',
            fontSize: 12,
            height: 'auto',
            lineHeight: '16px',
            padding: '14px 32px 23px 8px',

            '& .hint-message-image:before': {
              fontFamily: iconFontFamily,
              fontSize: 16,
              lineHeight: '16px',
              marginRight: 8,
              content: '"\\E946"',
            },
          },
        },

        '& .notification-queue-content': {
          padding: '0px 20px 0px 16px',
          flex: 1,
          overflow: 'auto',

          '& .notification-severity': {
            marginTop: 40,
            marginBottom: 0,

            '& .notification-severity-header': {
              lineHeight: '22px',
              fontWeight: 600,
              paddingBottom: 5,
              color: '#323130',
            },

            '& hr': {
              display: 'none',
            },

            '& .notification-item': {
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 12,
              marginRight: 5,
              backgroundColor: '#FFFFFF',
              boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
              borderRadius: 2,
              padding: '21px 18px 9px 18px',
              width: 425,
              position: 'relative',

              '& .left': {
                display: 'flex',
                justifyContent: 'center',
                width: 20,
                position: 'absolute',
              },

              '& .center': {
                width: '100%',
                paddingLeft: 32,
                color: '#333333',

                '& .title': {
                  display: 'block',
                  lineHeight: '22px',
                  fontWeight: 600,
                  paddingBottom: 0,
                },

                '& .message': {
                  display: 'block',
                  lineHeight: '22px',
                  fontSize: 12,
                  paddingBottom: 6,

                  '& .insight_icon': {
                    fontFamily: iconFontFamily,
                    color: palette.themePrimary,
                  },

                  '& .insight_icon:before': {
                    content: '"\\E3AF"',
                  },
                },

                '& .actions': {
                  display: 'block',
                  marginLeft: '-30px',
                  paddingTop: 13,
                  borderTop: '1px solid #E1DFDD',

                  '& .action-link': {
                    listStyleType: 'none',
                    marginRight: 18,
                    fontSize: 14,
                    height: 22,
                    lineHeight: '22px',
                    color: '#0078D4',

                    '& .btn-link': {
                      color: '#0078D4',
                      height: 22,
                      padding: '0 4px',
                    },
                  },

                  '& .action-link:last-child': {
                    marginRight: 0,
                  },
                },
              },
            },
          },

          '& .notification-severity:first-child': {
            marginTop: 0,
          },
        },
      },
    },
  },

});
